import { MathComparisonSymbol } from "./Math";

export type FilterByOperator = "=" | "!=";
export type ArrayMatchMethod = "all" | "any";

export type FilterByProps<T> = {
    name: keyof T,
    value: string | number | boolean,
    operator: FilterByOperator
}

export function typesenseNumberRangeFilter(field: string, start: number | null, end: number | null) {
    const parsedStart = tryGetNumber(start);
    const parsedEnd = tryGetNumber(end);

    if (parsedStart === null && parsedEnd === null) {
        return null;
    }

    if (parsedStart === null && parsedEnd !== null) {
        return `${field}:<=${parsedEnd}`;
    }

    if (parsedStart !== null && parsedEnd === null) {
        return `${field}:>=${parsedStart}`;
    }

    return `${field}:[${parsedStart}..${parsedEnd}]`;
}

export function typesenseNumberFilter(field: string, value: number | null, comparisonSymbol: MathComparisonSymbol) {
    if (!field || value === null || value === undefined || isNaN(value)) {
        return "";
    }

    return `${field}:${comparisonSymbol}${value}`;
}

export function typesenseExactStringFilter(field: string, value: string | null) {
    if (!field || value === null || value === undefined) {
        return "";
    }

    return `${field}:=${value}`;
}

export function typesenseMultiFilter(field: string, values: string[] | number[]) {
    return `${field}:[${values.join(',')}]`;
}

function tryGetNumber(value: number | null) {
    if (value === null || value === undefined || isNaN(value)) {
        return null;
    }

    return value;
}

export function typesenseArrayFilter<T>(field: string, items: T[], getValue: (item: T) => string, matchMethod: ArrayMatchMethod) {
    if (!items.length || !field || !getValue) {
        return "";
    }

    let filter = "";
    switch (matchMethod) {
        case "all":
            items.forEach((item, index) => {
                const value = getValue(item);

                if (index === 0) {
                    filter = `${field}:=\`${value}\``;
                } else {
                    filter = `${filter} && ${field}:=\`${value}\``;
                }
            });
        
            return filter;
        case "any":
            filter = `${field}:= [`;
            items.forEach((item, index) => {
                const value = getValue(item);
                if (index === 0) {
                    filter = `${filter}\`${value}\``;
                } else {
                    filter = `${filter}, \`${value}\``;
                }
            });
        
            filter = `${filter}]`;
            return filter;
        default:
            return "";
    }
}

export function typesenseAppend(filters: string, newFilter: string): string {
    if (!newFilter) {
        return filters;
    }

    return filters ? `${filters} && ${newFilter}` : newFilter;
}

export function getTypesenseLocation(latitude: number, longitude: number): number[] {
    return [latitude, longitude];
}